import { PageEvents } from '@griply/types';
import { Suspense } from 'react';
import * as React from 'react';
import { getSupportsBrowserSignIn } from 'shared/utils/get-supports-browser-sign-in';
import { DesktopSignIn } from 'shared/views/desktop-sign-in';

import { LoginView } from './components/login-view';

export const Login: React.FC = () => {
  if (getSupportsBrowserSignIn()) {
    return <DesktopSignIn pageEvent={PageEvents.Login} />;
  }

  return (
    <Suspense>
      <LoginView />
    </Suspense>
  );
};
